import { PeriodRequired, PeriodNotRequired, RequiredTimeUnit } from '../enums';
import { IRequiredDurationValues } from '../interfaces';
import { IFormat } from '../interfaces/IFormat';

/**
 * Non required and required matches for periods
 */
const periodMatches = [
    [PeriodNotRequired.Y, PeriodRequired.Y],
    [PeriodNotRequired.O, PeriodRequired.O],
    [PeriodNotRequired.W, PeriodRequired.W],
    [PeriodNotRequired.D, PeriodRequired.D],
    [PeriodNotRequired.H, PeriodRequired.H],
    [PeriodNotRequired.M, PeriodRequired.M],
    [PeriodNotRequired.S, PeriodRequired.S],
];

/**
 * Determine show values if it's required or optional
 */
export const determineRequiredDurationValues = (format: IFormat): IRequiredDurationValues =>
    periodMatches.map(([notRequired, required]) => {
        if (format.match(notRequired)) {
            return RequiredTimeUnit.NO;
        }

        if (format.match(required)) {
            return RequiredTimeUnit.YES;
        }

        return null;
    });
